<samweb-searchbar
   class="waitlist-searchbar"
   [searchText]="searchTextValue$ | async"
   [searchValue$]="searchValue$"
   (searchValueChangedDebounced)="handleFilterChange($event)"
>
</samweb-searchbar>
<ng-template #tooltipTemplate let-anchor>
   <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>
<ng-template #none let-anchor> </ng-template>

<kendo-grid
   samwebPersistKendoGrid
   kendoTooltip
   cdkDropList
   cdkDropListSortingDisabled
   [data]="filteredMessageList$ | async"
   [ngClass]="[
      (isMessageDragged$ | async) ? 'sam-cursor-no-drop' : 'sam-cursor-default',
      (isFilteredBySkill$ | async) ? 'waitlist-grid' : 'waitlist-grid-full-height'
   ]"
   [columnMenu]="true"
   [sortable]="!(isInboxSelected$ | async)"
   [sort]="sortDescription$ | async"
   (sortChange)="sortChange($event)"
   [resizable]="true"
   [reorderable]="true"
   showOn="none"
   [tooltipTemplate]="tooltipTemplate"
   #cellTooltipDirective="kendoTooltip"
   filter=".k-grid td"
   (mouseover)="showTooltip($event)"
   (mouseout)="hideTooltip()"
   (dblclick)="onRowDoubleClick($event)"
   (cellClick)="onCellClick($event)"
   [cdkDropListConnectedTo]="MailingSkillDropList$ | async"
   kendoGridSelectBy="messageId"
   [selectedKeys]="selectedKeys$ | async"
   (selectionChange)="selectionChanged($event)"
>
   <kendo-grid-column [width]="0">
      <!-- only added for dragging -->
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         <div
            *ngIf="(filteredGroup$ | async) !== SentKey && (filteredGroup$ | async) !== OutboxKey"
            cdkDrag
            cdkDragRootElement="tr"
            [cdkDragData]="dataItem"
            (cdkDragStarted)="dragStart($event)"
            (cdkDragEnded)="dragEnd($event)"
         >
            <div *cdkDragPreview class="sam-margin sam-center sam-padding dragged-item">
               <fa-icon [icon]="envelopeIcon" class="sam-margin-right"> </fa-icon>
               <span class="dragged-item-text">{{ dataItem.subject }}</span>
            </div>
         </div>
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column title="" [width]="(isInboxSelected$ | async) ? 43 : 0" [columnMenu]="false" [resizable]="false">
      <ng-template kendoGridHeaderTemplate>
         <fa-icon [icon]="skillIcon" class="header-icon sam-center" [fixedWidth]="true"></fa-icon>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         <fa-icon
            *ngIf="!dataItem.isSkillAvailable"
            [ngClass]="dataItem.hasNotSkillProgression ? 'sam-center sam-opacity-medium' : 'sam-center'"
            [fixedWidth]="true"
            [icon]="skillIcon"
         ></fa-icon>
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column
      field="skill.displayName"
      [title]="'brick.brick_definitions.mail_wait_list.columns.skill' | translate"
   >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         <samweb-skill-short-info
            [skills]="dataItem.skill.skills"
            [skillConfiguration]="dataItem.skill.skillConfiguration"
         ></samweb-skill-short-info>
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="subject" [title]="'brick.brick_definitions.mail_wait_list.columns.subject' | translate">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         <div class="sam-form-flex-row">
            <samweb-icon-with-colored-subicon
               *ngIf="dataItem.isParkedOnSkill"
               class="sam-center sam-margin-right-large skill-park-icon"
               [primaryIcon]="parkingIconSolid"
               [secondaryIcon]="skillIconSolid"
            ></samweb-icon-with-colored-subicon>
            <samweb-icon-with-colored-subicon
               *ngIf="dataItem.isParkedOnAgent"
               class="sam-center sam-margin-right-large agent-park-icon"
               [primaryIcon]="parkingIconSolid"
               [secondaryIcon]="userIconSolid"
            ></samweb-icon-with-colored-subicon>
            <fa-icon
               class="sam-center sam-wiggle sam-margin-right"
               *ngIf="dataItem.messageStatus.isAssigned"
               [icon]="mailIcon"
            ></fa-icon>
            <fa-icon
               class="sam-center sam-margin-right"
               *ngIf="dataItem.messageStatus.isOpened"
               [icon]="openedMailIcon"
            ></fa-icon>
            <span [innerHtml]="dataItem.subject | highlightText$: searchValue$:true | async | safeHtml"> </span>
         </div>
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column
      field="address"
      [title]="'brick.brick_definitions.mail_wait_list.columns.sender-receiver' | translate"
   >
      <ng-template kendoGridHeaderTemplate>
         <span
            *ngIf="
               (filteredGroup$ | async) !== SentKey &&
               (filteredGroup$ | async) !== OutboxKey &&
               (filteredGroup$ | async) !== DeletedKey
            "
         >
            {{ 'brick.brick_definitions.mail_wait_list.columns.sender' | translate }}
         </span>
         <span *ngIf="(filteredGroup$ | async) === SentKey || (filteredGroup$ | async) === OutboxKey">
            {{ 'brick.brick_definitions.mail_wait_list.columns.receiver' | translate }}
         </span>
         <span *ngIf="(filteredGroup$ | async) === DeletedKey">
            {{ 'brick.brick_definitions.mail_wait_list.columns.sender-receiver' | translate }}
         </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         <span [innerHtml]="dataItem.address | highlightText$: searchValue$:true | async | safeHtml"> </span>
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column
      [hidden]="isOutboxSelected$ | async"
      field="timestamp"
      [title]="'brick.brick_definitions.mail_wait_list.columns.send-received' | translate"
   >
      <ng-template kendoGridHeaderTemplate>
         <span *ngIf="(filteredGroup$ | async) === SentKey || (filteredGroup$ | async) === OutboxKey">
            {{ 'brick.brick_definitions.mail_wait_list.columns.send' | translate }}
         </span>
         <span
            *ngIf="
               (filteredGroup$ | async) !== SentKey &&
               (filteredGroup$ | async) !== OutboxKey &&
               (filteredGroup$ | async) !== DeletedKey
            "
         >
            {{ 'brick.brick_definitions.mail_wait_list.columns.received' | translate }}
         </span>
         <span *ngIf="(filteredGroup$ | async) === DeletedKey">
            {{ 'brick.brick_definitions.mail_wait_list.columns.send-received' | translate }}
         </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         {{ dataItem.timestamp | toMoment$ | async | amDateFormat: 'LLL' }}
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="memo" [title]="'brick.brick_definitions.mail_wait_list.columns.memo' | translate">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         <span *ngIf="!(isInboxSelected$ | async)">
            {{ dataItem.memo }}
         </span>
         <samweb-call-memo-cell
            *ngIf="isInboxSelected$ | async"
            [callId]="dataItem.callId"
            [memo]="dataItem.memo"
            [messageId]="dataItem.messageId"
         >
         </samweb-call-memo-cell>
      </ng-template>
   </kendo-grid-column>

   <ng-template kendoGridNoRecordsTemplate>
      <samweb-grid-wait-for-data
         [noRecords]="true"
         [wasSearchingEverStarted$]="wasSearchEverExecuted$"
         [disableInfinityScrollDuringLongRunningCategories]="['MAIL_WAITLIST']"
      >
      </samweb-grid-wait-for-data>
   </ng-template>
</kendo-grid>

<samweb-skill-filter-bar
   [isFilteredBySkill]="isFilteredBySkill$ | async"
   [filteredGroupTranslationValue]="filteredGroupTranslationValue$ | async"
   [filteredSkill]="filteredSkill$ | async"
>
</samweb-skill-filter-bar>
